// Externe Bibliotheken
import { Link } from 'react-router';
import { useContext } from 'react';

// Interne Module
import { AppContext } from '@/context//AppContext';

// Styles
import './backButton.scss';

export const BackButton = (props) => {
    const context = useContext(AppContext);

    const label = props?.label ?? context?.constants.BACK_TO_MY_TRIP ?? 'Zurück zu meiner Reise';

    if (props.target === 'blank') {
        return (
            <a
                href="/"
                rel="noopener noreferrer"
                className={`back-button ${props.class || ''}`}
                onClick={() => {
                    window.close();
                }}>
                <i className="material-icons left">keyboard_arrow_left</i>
                {label}
            </a>
        );
    } else {
        return (
            <Link to={props.to ?? '/'} className={`back-button ${props.class || ''}`}>
                <i className="material-icons left">keyboard_arrow_left</i>
                {props.text ? props.text : <>{label}</>}
            </Link>
        );
    }
};
export default BackButton;
